function hasFileExtension(pathname: string) {
  // Rough heuristic: if the last segment contains a dot, treat it as a file.
  // Examples: "/favicon.ico", "/assets/app.js", "/sitemap.xml"
  const last = pathname.split('/').filter(Boolean).at(-1) ?? '';
  return last.includes('.');
}

export function stripTrailingSlash(pathname: string) {
  if (pathname === '/') return '/';
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

export function isSpaOnlyPath(pathname: string) {
  return pathname === '/app' ||
    pathname.startsWith('/app/') ||
    pathname === '/auth' ||
    pathname.startsWith('/auth/');
}

/**
 * Canonicalize public (crawlable) paths.
 *
 * Rules:
 * - "/" stays "/"
 * - "/app/*" and "/auth/*" are excluded (SPA-only)
 * - Paths that look like files (have an extension) are left as-is
 * - Everything else becomes "/path" (no trailing slash)
 */
export function toPublicTrailingSlashPath(pathname: string) {
  if (!pathname) return '/';
  if (!pathname.startsWith('/')) pathname = `/${pathname}`;

  if (pathname === '/') return '/';
  if (isSpaOnlyPath(pathname)) return pathname;
  if (hasFileExtension(pathname)) return pathname;

  return stripTrailingSlash(pathname);
}

